var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Summary',{attrs:{"heading":_vm.setting.header,"heading-icon":"cipPicture","palette":_vm.setting.palette,"tooltip":_vm.setting.tooltip,"heading-value":_vm.heading,"rows":_vm.rows}})}
var staticRenderFns = []

export { render, staticRenderFns }